import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=2687b932&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=2687b932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687b932",
  null
  
)

export default component.exports